<template>
  <div>
    <b-form-group
      v-if="!EgressProfile"
      :label="`${$getVisibleNames(
        'mesh.egressprofile',
        false,
        'Perfil de egreso'
      )}:`"
      label-for="select-egress-profile"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-select
        id="select-egress-profile"
        name="select-egress-profile"
        :options="egress_profiles"
        value-field="id"
        text-field="name"
        v-model="$v.certification.egress_profile.$model"
        @change="
          () => {
            certification.matters = [];
            fetchMatter();
          }
        "
        :state="validateState('egress_profile')"
        aria-describedby="select-egress-profile-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      >
        <template #first>
          <b-form-select-option :value="null">
            {{
              $t("reusable.common.selectOption", {
                entity: $getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de egreso"
                ),
              })
            }}
          </b-form-select-option>
        </template>
      </b-form-select>
      <b-form-invalid-feedback id="select-egress-profile-live-feedback">{{
        $t("reusable.common.mustSelect", {
          entity: $getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de egreso"
          ),
        })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.name') + ':'"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.certification.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
        class="input-name"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description') + ':'"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="form-description mb-2"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="certification.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="certification"
        :content_rich_text="certification.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(certification, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="certification"
          :Text="certification.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.certification.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="
        $getVisibleNames('mesh.egressprofilematter', true, 'Asignaturas') + ':'
      "
      label-for="input-matters"
      label-cols="0"
      label-cols-sm="3"
      class="sm p-0 m-0"
    >
      <b-form-select
        v-if="prerequisitesOptions.length > 0"
        id="input-matters"
        v-model="$v.certification.matters.$model"
        :options="prerequisitesOptions"
        value-field="id"
        text-field="name"
        :state="validateState('matters')"
        aria-describedby="input-matters-feedback"
        size="sm"
        multiple
        :select-size="
          prerequisitesOptions.length <= 5
            ? prerequisitesOptions.length + 1
            : 15
        "
      ></b-form-select>
      <div class="pt-2" v-else>
        {{
          $t("curricularDefinitions.certification.noMattersInProfile", {
            profile: $getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de egreso"
            ),
            matters: $getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            ),
          })
        }}
      </div>
      <b-form-invalid-feedback id="input-matters-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.certification.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="certification"></ModificationDate>
    </b-form-group>
    <div class="row mt-3">
      <div
        v-if="show_delete_button && !isNaN(this.certification.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteCertification"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0 mr-1" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId, toast } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "CertificationForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    EgressProfile: {
      type: Object,
      default: null,
    },
    Certification: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          egress_profile: this.EgressProfile ? this.EgressProfile.id : null,
          matters: [],
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      certification: { ...this.Certification },
      matters_in_egress_profile: [],
    };
  },
  validations: {
    certification: {
      name: {
        required,
        minLength: minLength(3),
      },
      description: {},
      matters: {},
      egress_profile: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      egress_profiles: names.EGRESS_PROFILES,
    }),
    prerequisitesOptions() {
      let list = [];
      if (!this.certification.egress_profile) return list;
      list = this.matters_in_egress_profile;
      return list.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    },
  },
  methods: {
    patchDescription(object, text) {
      this.certification.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.certification[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.certification.$touch();
      if (this.$v.certification.$anyError) {
        return;
      }
      if (isNaN(this.certification.id)) {
        this.createCertification();
      } else this.updateCertification();
    },
    fetchMatter() {
      if (this.certification && this.certification.egress_profile) {
        this.$store
          .dispatch(names.FETCH_MATTERS, {
            egress_profile_id: this.certification.egress_profile,
          })
          .then((response) => (this.matters_in_egress_profile = response));
      }
    },
    createCertification() {
      this.$store
        .dispatch(names.POST_CERTIFICATION, this.certification)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.certification",
                false,
                "Certificación de Credenciales"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateCertification() {
      this.$store
        .dispatch(names.UPDATE_CERTIFICATION, this.certification)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.certification",
                false,
                "Certificación de Credenciales"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteCertification() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.certification",
            false,
            "Certificación de Credenciales"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_CERTIFICATION,
            this.certification.id
          );
          this.$emit("deleted", this.certification);
        }
      });
    },
  },
  created() {
    this.fetchMatter();
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
.label {
  margin-top: 1%;
}
.input-name {
  margin-top: -1px;
}
#input-color {
  cursor: pointer;
}
</style>